import axios from "axios";
import { API } from "../config/BackendUrl";
const url = `${API}/mintingpost`;

export const CreateLazyPost = async (formData) => {
  const config = {
    method: "POST",
    url: `${url}/create`,
    data: formData,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const SingleLazyPostDetails = async (id) => {
  const config = {
    method: "get",
    url: `${url}/${id}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getCollectionNFTs = async (contractAddress) => {
  const config = {
    method: "get",
    url: `${url}/contractAddress/${contractAddress}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };

  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getAllLazyPost = async () => {
  const config = {
    method: "get",
    url: `${url}/`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const getAllNFTs = async (page, limit) => {
  const config = {
    method: "get",
    url: `${url}/nft/all/${page}/${limit}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};
export const LazyPostUpdate = async (formData, id) => {
  const config = {
    method: "patch",
    url: `${url}/${id}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    data: JSON.stringify(formData),
  };
  try {
    const res = await axios(config);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const DeleteLazyPost = async (id) => {
  const config = {
    method: "delete",
    url: `${url}/${id}`,
    headers: {
      "Content-Type": "file/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response;
  }
};

